import React from "react";


function FootfallIcon(props) {

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" { ...props }>
      <path d="M4 18.0015H9.5V19.2515C9.5 19.9809 9.21027 20.6804 8.69454 21.1961C8.17882 21.7118 7.47935 22.0015 6.75 22.0015C6.02065 22.0015 5.32118 21.7118 4.80546 21.1961C4.28973 20.6804 4 19.9809 4 19.2515V18.0015ZM8 6.12154C10 6.12154 11 9.00154 11 11.0015C11 12.0015 10.5 13.0015 10 14.5015L9.5 16.0015H4C4 15.0015 3.5 13.5015 3.5 11.0015C3.5 8.50154 5.498 6.12154 8 6.12154ZM20.054 14.0995L19.837 15.3305C19.7104 16.0489 19.3035 16.6875 18.7061 17.1059C18.1086 17.5243 17.3693 17.6882 16.651 17.5615C15.9327 17.4349 15.2941 17.0281 14.8757 16.4306C14.4573 15.8331 14.2934 15.0939 14.42 14.3755L14.638 13.1455L20.054 14.0995ZM18.178 1.70654C20.642 2.14054 22.196 4.83054 21.762 7.29254C21.328 9.75554 20.575 11.1455 20.402 12.1305L14.985 11.1755L14.753 9.61154C14.521 8.04754 14.203 6.97554 14.376 5.99154C14.723 4.02154 16.208 1.35954 18.178 1.70654Z" fill="white"/>
    </svg>
  );
}

export default FootfallIcon;
